<template>
  <div class="units">
    <h1>Bereiche</h1>
    <ul>
      <li>
        <p>Bereich wechseln (mehrere Gemeinden verwalten)</p>
      </li>
      <li>
        <p>Duplizieren und neue Entwürfe entwickeln</p>
      </li>
      <li>
        <p>Layer in Luucy darstellen</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data () {
    return {
      unidId: -1
    }
  }
}
</script>

<style scoped>
h1, h2 {
  font-weight: normal;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/UnitSelection.vue